<div class="modal-header" [ngClass]="{'p-header' : !title}">
    <h4 class="modal-title" id="modal-title">{{ title }}</h4>
    <button *ngIf="!hideClose" type="button" class="btn-close" (click)="onCloseClick.emit()">
        <i class="fas fa-times"></i>
    </button>
</div>
